(() => {
  class ProductPageSunum extends HTMLElement {
    constructor() {
      super();

      this.card = null;
      this.observer = null;
      this.frame = null;

      this.handlePointerMove = this.handlePointerMove.bind(this);
      this.resetCardPosition = this.resetCardPosition.bind(this);
    }

    connectedCallback() {
      if (this.dataset.initialized === 'true') return;

      this.dataset.initialized = 'true';
      this.card = this.querySelector('[data-pps-card]');

      this.setupReveal();
      this.setupCardTilt();
    }

    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
      }

      if (this.card) {
        this.card.removeEventListener(
          'pointermove',
          this.handlePointerMove
        );

        this.card.removeEventListener(
          'pointerleave',
          this.resetCardPosition
        );
      }

      if (this.frame) {
        window.cancelAnimationFrame(this.frame);
      }
    }

    setupReveal() {
      const reduceMotion = window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches;

      if (reduceMotion || !('IntersectionObserver' in window)) {
        this.classList.add('is-visible');
        return;
      }

      this.classList.add('pps--js');

      this.observer = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;

            this.classList.add('is-visible');
            observer.unobserve(entry.target);
          });
        },
        {
          threshold: 0.12,
          rootMargin: '0px 0px -8% 0px'
        }
      );

      this.observer.observe(this);
    }

    setupCardTilt() {
      if (!this.card) return;

      const supportsHover = window.matchMedia(
        '(hover: hover) and (pointer: fine) and (min-width: 990px)'
      ).matches;

      const reduceMotion = window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches;

      const isThemeEditor =
        window.Shopify &&
        window.Shopify.designMode;

      if (!supportsHover || reduceMotion || isThemeEditor) return;

      this.card.addEventListener(
        'pointermove',
        this.handlePointerMove
      );

      this.card.addEventListener(
        'pointerleave',
        this.resetCardPosition
      );
    }

    handlePointerMove(event) {
      if (!this.card) return;

      const bounds = this.card.getBoundingClientRect();

      const pointerX =
        (event.clientX - bounds.left) / bounds.width;

      const pointerY =
        (event.clientY - bounds.top) / bounds.height;

      const rotateY = (pointerX - 0.5) * 6;
      const rotateX = (0.5 - pointerY) * 6;

      if (this.frame) {
        window.cancelAnimationFrame(this.frame);
      }

      this.frame = window.requestAnimationFrame(() => {
        this.card.style.setProperty(
          '--pps-tilt-x',
          `${rotateX.toFixed(2)}deg`
        );

        this.card.style.setProperty(
          '--pps-tilt-y',
          `${rotateY.toFixed(2)}deg`
        );
      });
    }

    resetCardPosition() {
      if (!this.card) return;

      if (this.frame) {
        window.cancelAnimationFrame(this.frame);
      }

      this.frame = window.requestAnimationFrame(() => {
        this.card.style.setProperty('--pps-tilt-x', '0deg');
        this.card.style.setProperty('--pps-tilt-y', '0deg');
      });
    }
  }

  if (!customElements.get('product-page-sunum')) {
    customElements.define(
      'product-page-sunum',
      ProductPageSunum
    );
  }
})();